import { PlanFlagKey } from '@/shared/user-plan/user-spec';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface FeatureBlockedDialogStore {
  open: boolean;
  feature?: PlanFlagKey;
  planNameOverride?: string;
  includePlanned?: boolean;
  customTitle?: string;
  customDescription?: string;
  highlightPlans?: number[];
}

export interface FeatureBlockedDialogStoreActions {
  setOpen: (open: boolean) => void;
  setFeature: (feature: PlanFlagKey) => void;
  setPlanNameOverride: (planNameOverride: string) => void;
  setIncludePlanned: (includePlanned: boolean) => void;
  setDialogData: (
    payload:
      | {
          open: boolean;
          feature: PlanFlagKey;
          includePlanned?: boolean;
        }
      | {
          open: boolean;
          planNameOverride: string;
          customTitle?: string;
          customDescription?: string;
          highlightPlans?: number[];
        },
  ) => void;
  reset: () => void;
}

export const useFeatureBlockedDialogStore = create<
  FeatureBlockedDialogStore & FeatureBlockedDialogStoreActions
>()(
  devtools((set) => ({
    open: false,
    feature: undefined,
    planNameOverride: undefined,
    includePlanned: true,
    customTitle: undefined,
    customDescription: undefined,
    highlightPlans: undefined,
    setOpen: (open: boolean) => set({ open }),
    setFeature: (feature: PlanFlagKey) =>
      set({ feature, planNameOverride: undefined }),
    setIncludePlanned: (includePlanned: boolean) => set({ includePlanned }),
    setPlanNameOverride: (planNameOverride: string) =>
      set({ planNameOverride, feature: undefined }),
    setDialogData: (payload) => {
      if ('planNameOverride' in payload) {
        set({
          open: payload.open,
          planNameOverride: payload.planNameOverride,
          feature: undefined,
          customTitle: payload.customTitle,
          customDescription: payload.customDescription,
          highlightPlans: payload.highlightPlans,
        });
        return;
      }

      set({
        open: payload.open,
        feature: payload.feature,
        includePlanned: payload.includePlanned ?? true,
        planNameOverride: undefined,
        customTitle: undefined,
        customDescription: undefined,
        highlightPlans: undefined,
      });
    },
    reset: () =>
      set({
        open: false,
        feature: undefined,
        planNameOverride: undefined,
        includePlanned: true,
        customTitle: undefined,
        customDescription: undefined,
        highlightPlans: undefined,
      }),
  })),
);
